SNI.Application.addModule('episode-list', function(context) {

  return {
    behaviors: ['truncate']
  };

});
